import { useAuthUserQuery, useMounted } from "@/hooks";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import { useEffect } from "react";
export function useRequireLogout() {
  const router = useRouter();
  const mounted = useMounted();
  const {
    data,
    loading
  } = useAuthUserQuery({
    fetchPolicy: "cache-first"
  });
  useEffect(() => {
    if (mounted && !loading && data !== null && data !== void 0 && data.user) {
      router.push(routes.home);
    }
  }, [mounted, loading, data === null || data === void 0 ? void 0 : data.user]);
}